const ClientInGrid = props => {

    const client = props.client
    const selectClient = props.selectClient

    return(
        <>

            <div className="client-in-grid" onClick={() => selectClient(client)}>

                <h2>{client.Name}</h2>
                <div className="client-in-grid-info">{client.Address}</div>
                <div className="client-in-grid-info">{client.Representative}</div>
                <div className="client-in-grid-info">{client.Phone}</div>

            </div>

        </>
    )
}

export default ClientInGrid